import React from "react";

const VillaDescription = ({ description }) => {
  return (
    <div className="flex flex-col mb-4 lg:mb-8">
      <span className="block mb-5 text-2xl font-bold leading-normal text-themeBlack">
        Villa Hakkında
      </span>
      <div className="text-sm font-normal leading-6 text-themeBlack text-opacity-70 text-ellipsis">
        <div
          className="flex flex-wrap gap-3"
          dangerouslySetInnerHTML={{ __html: description }}
        />
      </div>
    </div>
  );
};

export default VillaDescription;
